export default __webpack_public_path__ + "static/Logo-daa41d6aa89a426b32edd4053315d3f0.svg";